import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import { NotificationGroup } from '@progress/kendo-react-notification';
import { Notification } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';

import { removeMessage, messageTimer } from './messageSlice'

export default function PopupMessages() {
	
	const messages = useSelector((state) => state.messages.messageList);
	const dispatch = useDispatch();
	const matches = window.matchMedia("(min-width: 768px)").matches;
	
	useEffect(() => {
        setInterval(() => { dispatch(messageTimer(2)); }, 1000);
    }, []);

	let msgItems = messages.filter((message) => matches || message.displayOverride).map((message) => 
		<div 
			className={message.hidden ? "constituo-visually-hidden" : ""}
			id={"popupCloseWrapper"} 
			key={message.msgIdx} 
			onClick={(e) => {
			    e.preventDefault();
			    e.stopPropagation();
			    dispatch(removeMessage(message.msgIdx));
			}}
			role="alert"
			aria-live="polite"
			aria-label={message.type}
		>
			<Notification
	        	type={{
	               	icon: true,
	               	style: message.type
				}}
				style={{ display: "inline-flex", width: "300px", maxWidth: "300px" }}
				closable={false}
			>
		       	{message.msg}
			</Notification>
		</div>
	);
	
	return (			
		<NotificationGroup
		   	style={{
		       	right: 0,
		       	bottom: 0,
		       	zIndex: 20000
		   	}} >
		   	<Fade>
				{msgItems}
			</Fade>
		</NotificationGroup>
	);
}
